import { render, staticRenderFns } from "./ReceptionDetailView.vue?vue&type=template&id=1d204337&scoped=true&"
import script from "./ReceptionDetailView.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDetailView.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDetailView.vue?vue&type=style&index=0&id=1d204337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d204337",
  null
  
)

export default component.exports